/* Coordinates the product-page app blocks (Panagora Raffle, Kiwi Sizing)
   with the theme. On raffle products the Panagora app replaces the div
   wrapping <product-form> with its own widget after fetching raffle data,
   so anything that reads or renders near the product form has to wait for
   that takeover to finish. The #raffle-hidden-elements style tag is
   server-rendered only on raffle products and removed by the app once its
   DOM takeover is done, so its absence means the page is settled. */
(() => {
  const raffleSettled = () => !document.getElementById('raffle-hidden-elements');

  // Kiwi's auto-render races the raffle takeover and dies silently when it
  // loses (its error handler only logs remotely, and it never retries).
  // main-product.liquid sets window.disableDefaultKiwiSizingLoad, and we
  // trigger the one render ourselves once the page is settled. Calling
  // loadKiwiSizingChart twice duplicates the chart, hence the single timer.
  const kiwiStart = Date.now();
  const kiwiTimer = setInterval(() => {
    if (Date.now() - kiwiStart > 20000) {
      clearInterval(kiwiTimer);
      return;
    }
    if (typeof window.loadKiwiSizingChart !== 'function') return;
    if (raffleSettled() || Date.now() - kiwiStart > 8000) {
      clearInterval(kiwiTimer);
      window.loadKiwiSizingChart();
    }
  }, 150);

  // The raffle signup form tracks the variant via a hidden [name="id"]
  // input and normally relocates the theme's variant picker inside itself
  // to watch it. The picker is kept in its usual spot under the price
  // (selector_variants is blank in the app block settings), so forward the
  // theme's variant changes to the raffle form instead. Dispatching
  // 'change' makes the app toggle its submit button.
  const setRaffleVariant = (variantId) => {
    const input = document.querySelector('panagora-raffle-form [name="id"]');
    if (!input || !variantId || input.value === String(variantId)) return;
    input.value = variantId;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => setRaffleVariant(data.variant?.id));

  // Seed the initial selection: with selector_variants blank the app skips
  // its own seeding, and the form only renders for signed-in customers
  // once the takeover completes, so poll briefly for it.
  const seedStart = Date.now();
  const seedTimer = setInterval(() => {
    if (Date.now() - seedStart > 15000) {
      clearInterval(seedTimer);
      return;
    }
    const input = document.querySelector('panagora-raffle-form [name="id"]');
    if (!input) return;
    clearInterval(seedTimer);
    if (input.value) return;
    const selected = document.querySelector('variant-selects [data-selected-variant]');
    let variantId;
    try {
      variantId = selected && JSON.parse(selected.textContent).id;
    } catch (error) {
      variantId = undefined;
    }
    if (!variantId) {
      const raffleData = document.getElementById('panagora-raffle-data');
      try {
        variantId = raffleData && JSON.parse(raffleData.textContent).firstVariant;
      } catch (error) {
        variantId = undefined;
      }
    }
    setRaffleVariant(variantId);
  }, 200);
})();
